module.exports = __webpack_public_path__ + "static/img/voice3_left.99873764.png";